import React, { useContext } from 'react'
import gql from "graphql-tag"
import * as Yup from 'yup'
import { Formik, Field } from 'formik'

import { showNotification } from '@/state/user-interface'
import { TextField } from '@/components/common/formik'
import { SpinnerButton } from '@/components/common/button'
import { useAppDispatch } from '@/utils/hooks'
import { userManagementEditUrl } from '@/utils/url'
import { useGlobalContext } from '@/components/context'
import { useRouter } from '@/components/context'
import generalStyle from '@sass/common/general.module.sass'
import formStyle from '@sass/common/form.module.sass'
import { UserListContext } from '../context'
import { useSaveUserMutation } from './__gen/form'

gql`
	mutation saveUser(
		$id: ID,
		$firstName: String!,
		$lastName: String!,
		$email: String!,
		$organisation: ID!,
	) {
		user_Update(input: {
			id: $id,
			firstName: $firstName,
			lastName: $lastName,
			email: $email,
			organisation: $organisation,
		}) {
			errors {
				messages
				field
			}
			object {
				id
				firstName
				lastName
				email
			}
		}
	}
`

type Props = {
	user: {
		id?: string
		firstName: string
		lastName: string
		email: string
	}
}

export default ({ user }: Props) => {
	const [saveUser, {}] = useSaveUserMutation()
	const refetchList = useContext(UserListContext)
	const globalContext = useGlobalContext()
	const router = useRouter()
	const dispatch = useAppDispatch()

	return (
		<Formik
			initialValues={user}
			validationSchema={Yup.object().shape({
				email: Yup.string().email('Invalid email format').required('Required'),
				firstName: Yup.string().required('Required'),
				lastName: Yup.string().required('Required'),
			})}
			onSubmit={(values, actions) => {
				saveUser({variables: {...values, organisation: globalContext.organisation.id}}).then((r) => {
					if (r.data?.user_Update?.errors) {
						actions.setErrors({email: r.data?.user_Update?.errors.map((e: any) => e.messages).join(', ')})
					}
					actions.setSubmitting(false)
					if(!values.id) {
						//redirect to edit user page
						router.history.push(userManagementEditUrl(r.data!.user_Update!.object!.id))
						refetchList()
						dispatch(showNotification({content: 'Invitation sent!'}))
					} else {
						dispatch(showNotification({content: 'User saved'}))

					}
				}).catch((r) => {
					console.error(r)
					actions.setSubmitting(false)
					actions.setStatus("An unexpected error occurred, if this persists please contact support.")
				}).finally(() => {
				})
			}}
		>
			{props => {
				const { errors ,isSubmitting ,handleSubmit } = props
				return (
					<React.Fragment>
						<div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
							<form onSubmit={handleSubmit} className={formStyle.commonForm}>
								<Field
									name="firstName"
									placeholder="First name"
									component={TextField}
								/>
								<Field
									name="lastName"
									placeholder="Last name"
									component={TextField}
								/>
								<Field
									name="email"
									placeholder="Email"
									component={TextField}
								/>
								<div
									style={{display: 'flex', justifyContent: 'space-around', width: 200}}
									className={formStyle.formButton}
								>
									<SpinnerButton loading={isSubmitting} type="submit">
										{user.id ? 	'Save' : 'Send invitation'}
									</SpinnerButton>
								</div>
								
							</form>
						</div>
					</React.Fragment>
				)
			}}
		</Formik>
	)
}
